import AdvertisingUtils from './lib/AdvertisingUtils';

export default {
    setGameData: AdvertisingUtils.setGameData,
    getGameData: AdvertisingUtils.getGameData,
    setGameView: AdvertisingUtils.setGameView,
    getGameView: AdvertisingUtils.getGameView,
    setGameTab: AdvertisingUtils.setGameTab,
    getGameTab: AdvertisingUtils.getGameTab,
    setConf: AdvertisingUtils.setConf,
    init: AdvertisingUtils.init,
    getKeyVals: AdvertisingUtils.getKeyVals,
    setInstance: AdvertisingUtils.setInstance,
    getInstance: AdvertisingUtils.getInstance
};